import { Component, OnInit, Input } from '@angular/core';
import { trigger, state, style, transition, animate, group } from '@angular/animations';
import { DataService } from '../../shared/services/data.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { UtilsService } from '../../shared/services/utils.service';
import { SharedRequesterService } from '../../shared/services/shared-requester.service';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    animations: [
        trigger('slideInOut', [
            state('in', style({
                width: '240px'
            })),
            state('out', style({
                width: '64px'
            })),
            transition('in => out', [group([
                    animate('100ms ease-in', style({
                        width: '64px'
                    }))
                ])]),
            transition('out => in', [group([
                    animate('100ms ease-in', style({
                        width: '240px'
                    })),
                ])])
        ])
    ],
    standalone: false
})
export class MainComponent {

}
